/* ----------- Button draw on article page ----------- */
let articlePage = document.querySelector('.shopify-section--main-article');
if (articlePage) {
  // Get buttons
  let buttonDrawArticle = articlePage.querySelectorAll('.button--draw');

  // Button style
  let buttonStyleLine = '<div class="c-button__line-top-x"></div><div class="c-button__line-top-y"></div><div class="c-button__line-bottom-x"></div><div class="c-button__line-bottom-y"></div>';

  // Apply style
  for (var i = 0; i < buttonDrawArticle.length; i++) {
    applyStyle(buttonDrawArticle[i]);
  }
  function applyStyle(button) {
    button.insertAdjacentHTML("beforeend", buttonStyleLine);
    button.classList.add('button');
    button.classList.add('button--draw');
  }
}

/* ----------- Back to top button ----------- */
// Get the button
let mybutton = document.querySelector(".back-to-top");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};
function scrollFunction() {
  if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
    mybutton.classList.add('back-to-top--is-visible');
  } else {
    mybutton.classList.remove('back-to-top--is-visible');
  }
}
mybutton.addEventListener('click', () => {
  topFunction();
});

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}